import TicketStatus from "./TicketStatus/TicketStatus";
import Projects from "./Projects/Projects";
import FixVersions from "./FixVersions/FixVersions";
import { useStyles} from "./Utils";
import { Box, Grid, Paper } from "@mui/material";

const Filters = () => (
  <Box sx={{ flexGrow: 1 }}>
    <Grid container spacing={3}>
      <Grid item xs={4}>
        <Paper elevation={3} style={useStyles.paper}>
          Projects <br />
          <Projects />
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper elevation={3} style={useStyles.paper}>
          Fix Versions <br />
          <FixVersions />
        </Paper>
      </Grid>
      <Grid item xs={4}>
        <Paper elevation={3} style={useStyles.paper}>
          Ticket Status <br />
          <TicketStatus />
        </Paper>
      </Grid>
    </Grid>
  </Box>
);

export default Filters;
